/**
 * Field sets for Supabase queries
 * 
 * These field sets allow us to optimize our Supabase queries by only
 * selecting the fields we need for each use case.
 */

/**
 * Project field sets
 */
export const projectFields = {
  // Minimal fields for lists and references
  minimal: 'id,name',

  // Fields for listing projects
  list: 'id,name,description,genre,created_at,updated_at',

  // All fields for detailed view
  detail: '*',

  // Fields for project with current story
  withCurrentStory: 'id,name,description,genre,created_at,updated_at,current_story_id'
}

/**
 * Story field sets
 */
export const storyFields = {
  // Minimal fields for lists and references
  minimal: 'id,name',
  
  // Fields for listing stories
  list: 'id,name,plotline,status,genre,created_at,updated_at,project_id',
  
  // All fields
  detail: '*',
  
  // Full related data
  full: `
    id,
    name,
    plotline,
    status,
    genre,
    created_at,
    updated_at,
    project_id,
    characters (*),
    chapters (id,title,order_number,status,created_at,updated_at),
    timeline_events (*),
    story_entities (*)
  `
} 